import { List, Map } from 'immutable';
export function unpack_validation(vr, ...keys) {
    if (keys.length == 1) {
        const k = keys[0];
        if (vr == null) {
            return null;
        }
        if (typeof vr === 'string') {
            return null;
        }
        if (Map.isMap(vr)) {
            return vr.get(k) ?? null;
        }
        if (List.isList(vr)) {
            return vr.get(k) ?? null;
        }
        // return (vr as {[K in keyof T]: ValidationResult<T[K]>})[k];
        return vr[k] ?? null;
    }
    const [first, ...rest] = keys;
    // @ts-ignore
    return unpack_validation(unpack_validation(vr, first), ...rest);
}
export function with_root_as_2nd_arg(validator) {
    return (value) => validator(value, value);
}
